<template>
  <b-button class="p-0" variant="link" v-b-tooltip title="Copy Link to Clipboard" @click.prevent.stop="copyLink">
    <i class="fas fa-copy"></i>
  </b-button>
</template>

<script>
import GeneralMixins from "../../mixins/GeneralMixins.js";

export default {
  props: ['text'],
  mixins: [GeneralMixins],
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.text)
      this.showToast(`Link was copied to clipboard`)
    }
  }
}
</script>